import { PublicCallback } from 'globals/types';
import { handleError } from 'globals/errors';
import {
  fetchMessageAttachments,
  fetchHistoricalMessages,
} from 'core_main/api/messages';
import { DEFAULT_HISTORICAL_MESSAGE_PAGE_SIZE } from 'core/constants';
import { createGetHistoricalMessagesCallbackResponse } from './helpers';
import {
  HistoricalMessagesListMessage,
  GetHistoricalMessagesParameters,
} from './types';

const addAttachmentsToHistoricalMessages = (history) => {
  const messagePromises = history?.data?.map((val) => {
    return new Promise((resolve) => {
      const attachments = val?.relationships?.attachments;

      if (attachments) {
        fetchMessageAttachments(val.id).then((attachmentsResponses) => {
          resolve({ message: val, attachments: attachmentsResponses });
        });
        return;
      }

      resolve({ message: val });
    });
  }) as Promise<HistoricalMessagesListMessage>[];

  return Promise.allSettled(messagePromises).then((res) => {
    const messageList: HistoricalMessagesListMessage[] = [];
    res.forEach((message) => {
      if (message.status !== 'rejected') {
        messageList.push(message.value);
      } else {
        handleError(message.reason, {
          message: 'Error appending attachment(s) to historical message',
        });
      }
    });
    return {
      messages: messageList,
    };
  });
};

export const getHistoricalMessages = (
  parameters: GetHistoricalMessagesParameters,
  cb?: PublicCallback,
) => {
  const conversationId = parameters?.conversationId;
  const count = parameters?.count || DEFAULT_HISTORICAL_MESSAGE_PAGE_SIZE;
  const before = parameters?.before;

  return fetchHistoricalMessages(conversationId, {
    count,
    before,
  })
    .then(addAttachmentsToHistoricalMessages)
    .then((history) => {
      const callbackResponse = createGetHistoricalMessagesCallbackResponse(
        history?.messages,
        conversationId,
      );

      if (typeof cb === 'function') {
        cb(callbackResponse);
      }
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      handleError(error, { message: 'Failed to get historical messages' });
    });
};
